"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDeleteLeagueChannelMappingDto = instanceOfDeleteLeagueChannelMappingDto;
exports.DeleteLeagueChannelMappingDtoFromJSON = DeleteLeagueChannelMappingDtoFromJSON;
exports.DeleteLeagueChannelMappingDtoFromJSONTyped = DeleteLeagueChannelMappingDtoFromJSONTyped;
exports.DeleteLeagueChannelMappingDtoToJSON = DeleteLeagueChannelMappingDtoToJSON;
exports.DeleteLeagueChannelMappingDtoToJSONTyped = DeleteLeagueChannelMappingDtoToJSONTyped;
/**
 * Check if a given object implements the DeleteLeagueChannelMappingDto interface.
 */
function instanceOfDeleteLeagueChannelMappingDto(value) {
    if (!('reason' in value) || value['reason'] === undefined)
        return false;
    return true;
}
function DeleteLeagueChannelMappingDtoFromJSON(json) {
    return DeleteLeagueChannelMappingDtoFromJSONTyped(json, false);
}
function DeleteLeagueChannelMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'reason': json['reason'],
    };
}
function DeleteLeagueChannelMappingDtoToJSON(json) {
    return DeleteLeagueChannelMappingDtoToJSONTyped(json, false);
}
function DeleteLeagueChannelMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'reason': value['reason'],
    };
}
